import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { Toaster } from 'components/notification/Toaster';
import { func_validation } from 'functions';
import React, { useEffect, useState } from 'react';

export function useDeleteDebitNote(props) {
    const {
        isDebitNoteRecordUpdatedSuccessfully,
        totalRequests,
        selectedDebitNotes,
        deleteDebitNote_requesting
    } = props;

    const [isDeleting, setIsDeleting] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);

    function deleteDebitNote() {
        if (func_validation.isFunction(props.setAlertMsg)) props.setAlertMsg([]);
    
        if (func_validation.isArrayNotEmpty(selectedDebitNotes)) {
            selectedDebitNotes.map((debitNoteDetails, idx) => { 
                let id = func_validation.getObjectPropertyValue(debitNoteDetails, "Id");
    
                if (func_validation.isNumberValid(id) &&
                    func_validation.isFunction(props.deleteDebitNote)) {
    
                    props.deleteDebitNote(id);
                    setIsDeleting(true);
                }
            });
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 account.",
            });
        }
    }
    useEffect(() => {
        if (isDebitNoteRecordUpdatedSuccessfully) setIsDeleting(false);
    },[isDebitNoteRecordUpdatedSuccessfully]);

    let deleteModalDisplay = (
        <ConfirmationModal
            description={"The selected debit note(s) will be deleted."}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible}
            updateParentState={setIsModalVisible}
            handleOnConfirm={deleteDebitNote}
            isActionLoading={deleteDebitNote_requesting}
            isConfirmSuccessful={totalRequests == 0}
        />
    );
    
    return {
        deleteDebitNote,
        deleteModalDisplay,
        setIsModalVisible
    }
}